import { useCallback, useState } from 'react';

type Args = {
    defaultValues?: Record<string, any>;
};

const useForm = (args?: Args) => {
    const [formData, setFormData] = useState(
        args?.defaultValues ? { ...args.defaultValues } : {}
    );

    const handleChange = useCallback(
        (name: string) => (value: string | number | boolean) => {
            if (value.toString() === '') {
                setFormData((prevData) => ({ ...prevData, [name]: undefined }));
            } else {
                setFormData((prevData) => ({ ...prevData, [name]: value }));
            }
        },
        [setFormData]
    );

    return { formData, setFormData, handleChange };
};

export { useForm };
